<template>
  <div class="dashboard-history">
    <row :gutter="16">
      <i-col span="8">
        <div class="ms-container-header">
          <icon size="16" type="md-alert" />
          Общая информация
        </div>
        <card dis-hover>
          <user-card :user="user" />
        </card>
      </i-col>
      <i-col span="16">
        <div class="ms-container-header">
          <icon size="16" type="md-analytics" />
          Активность
        </div>
        <inline-loader v-if="loading" :loading="loading" />
        <card dis-hover v-else>
          <history-list
            v-if="actions.length"
            :actions="actions"
            :all="true"
          />
          <div class="ms-help ms-nodata" v-else>
            Вы не совершали никаких действий в системе
          </div>
        </card>
      </i-col>
    </row>
  </div>
</template>

<script>
import HistoryList from '@/components/history/history-list'
import UserCard from '@/components/users/user-card'
import InlineLoader from '@/components/loaders/inline-loader'

export default {
  components: {
    HistoryList,
    UserCard,
    InlineLoader
  },
  data () {
    return {
      loading: false,
      actions: [],
      id: this.$store.state.auth.user.id
    }
  },
  computed: {
    user () {
      return this.$store.state.auth.user
    }
  },
  methods: {
    async getData () {
      try {
        this.loading = true
        const url = `page/last_action?user_id=${this.id}`
        this.actions = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="less">
.dashboard-history {
}
</style>
